module.exports = __webpack_public_path__ + "static/media/privacy-week-splash-tablet-mobile.590a0c3b.png";